import { createContext, useContext } from "react";
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  // This function is used to set the auth data in session storage and cookies
  const setAuthData = (authData) => {

    if (authData) {
      const decodedAppData = authData ? JSON.parse(atob(authData)) : null;
      // Check if the decodedAppData is an array and has at least one element
      // (Ref:LED0008949) When we recived multiple Ilb case moret than 5, unable to store encrypted data in cookie due to size limit, 
      // so we are setting a flag in cookie to check if the data is valid or not
      const isAuthDataValid = decodedAppData && Object.keys(decodedAppData).length > 0 ? true : false;
      localStorage.setItem("appData", authData); // This will use when Payload is not available in local storage
      Cookies.set("authData", isAuthDataValid, getCookieOptions()); // Set in cookies for cross-subdomain access
    }

  };
  // This function is used to set the SSO auth data in cookies
  const setSSOAuthData = (ssoAuthData) => {
    if (ssoAuthData) {
      Cookies.set("authID", ssoAuthData, getCookieOptions());
    }
  }

  return (
    <AuthContext.Provider value={{ setAuthData, setSSOAuthData }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
